import { ErrorCode } from '@amzn/coral_com-amazon-passportusermanagementservice';

export const errorBodyForCodeMap: Record<string, string> = {
  [ErrorCode.INVITATION_ALREADY_EXISTS]:
    'create_invitation_notifications.invitation_already_exists',
  [ErrorCode.ALLOWED_DOMAINS_NOT_MATCHED]:
    'create_invitation_notifications.allowed_domains_not_matched',
  [ErrorCode.INVITED_USER_ALREADY_AUTHORIZED]:
    'confirm_invitation_notifications.invited_user_already_authorized',
  [ErrorCode.INVITATION_ALREADY_COMPLETED]:
    'delete_invitation_notifications.invitation_already_completed',
  [ErrorCode.INVITATION_IS_ACCEPTED_BY_DIFFERENT_CUSTOMER]:
    'accept_invitation_notifications.invitation_accepted_by_different_customer',
  [ErrorCode.INVITATION_IS_ALREADY_ACCEPTED]:
    'accept_invitation_notifications.invitation_already_accepted',
  [ErrorCode.ACCEPTED_USER_IS_ALREADY_AUTHORIZED]:
    'accept_invitation_notifications.accepted_user_already_authorized',
};

// TODO: temporarily kept this error msg fragment to compute if user dont have permission for GetUsersForLogisticsParty
// Ideally 403 status should be used for unauthorized but currently 500 status is being sent by API
export const UNAUTHORIZED_ERROR_MSG_FRAGMENT =
  'does not have enough permissions for operations: GetUsersForLogisticsParty';

export const deactivateUserErrorCodes = {
  [ErrorCode.DEACTIVATING_ADMIN_USER_ERROR]:
    'manage_users.deactivate_user.error_codes.admin_deactivation_error',
};
